export type GuidedMediaSize = 'default' | 'thumbnail'

export interface MediaSizeInput {
  hasMedia: boolean
  isMultiQuestionPage: boolean
  hasAnswer: boolean
  requiresEntryCompletion: boolean
  entryComplete: boolean
  isBlocking: boolean
  override: GuidedMediaSize | null
}

export function mediaSizeFor(input: MediaSizeInput): GuidedMediaSize {
  if (!input.hasMedia) return 'default'
  if (!input.isMultiQuestionPage) return 'default'
  if (input.override) return input.override

  const entrySatisfied = !input.requiresEntryCompletion || input.entryComplete
  return input.hasAnswer && entrySatisfied && !input.isBlocking ? 'thumbnail' : 'default'
}

export function requiresEntryCompletion(collectionType: string): boolean {
  return collectionType === 'numeric'
    || collectionType === 'text'
    || collectionType === 'blood_pressure'
    || collectionType === 'date'
    || collectionType === ''
}
